import React, { VFC } from 'react'
import { MasterDataWithCategory } from 'src/models/MasterData'
import styled from 'styled-components'

type NeedsTagSelectProps = {
  value: string
  onChange: (value: string) => void
  items: MasterDataWithCategory[]
  placeholder?: string
}

export const ContentTagSelect: VFC<NeedsTagSelectProps> = ({
  value,
  onChange,
  items,
  placeholder = '選択してください',
}) => {
  const categories = [
    {
      title: '経営戦略・事業開発',
      items: items.filter((item) => item.category === '経営戦略・事業開発'),
    },
    {
      title: 'ブランディング・マーケティング',
      items: items.filter(
        (item) => item.category === 'ブランディング・マーケティング',
      ),
    },
    {
      title: 'セールス強化・売上拡大',
      items: items.filter((item) => item.category === 'セールス強化・売上拡大'),
    },
    {
      title: '人材採用',
      items: items.filter((item) => item.category === '人材採用'),
    },
    {
      title: '人・組織づくり',
      items: items.filter((item) => item.category === '人・組織づくり'),
    },
    {
      title: '業務改善・システム開発・デジタル化',
      items: items.filter(
        (item) => item.category === '業務改善・システム開発・デジタル化',
      ),
    },
    {
      title: '財務・資金管理・バックオフィス',
      items: items.filter(
        (item) => item.category === '財務・資金管理・バックオフィス',
      ),
    },
    {
      title: 'その他',
      items: items.filter((item) => item.category === 'その他'),
    },
  ]

  return (
    <Layout>
      <Select
        value={value}
        onChange={(e: React.ChangeEvent<HTMLSelectElement>) =>
          onChange(e.target.value)
        }
      >
        <option value="">{placeholder}</option>
        {categories.map(({ title, items: categoryItems }) => (
          <optgroup key={title} label={title}>
            {categoryItems.map((item) => (
              <option key={item.value} value={item.value}>
                {item.label}
              </option>
            ))}
          </optgroup>
        ))}
      </Select>
    </Layout>
  )
}

const Layout = styled.div`
  width: 100%;
`

const Select = styled('select')`
  display: block;
  width: 100%;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 15px 36px 15px 20px;
  font-size: 14px;
  background: white;
  cursor: pointer;

  &:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
  }

  option {
    padding: 8px;
  }

  optgroup {
    font-weight: bold;
    color: #666;
    background-color: #f8f9fa;
  }
`
